<template>
  <div>
    <RewardsComponent />
  </div>
</template>

<script>
import RewardsComponent from './components/Index.vue'

export default {
  name: 'RewardsIndex',
  components: {
    RewardsComponent,
  }
}
</script>